import { MergeFormSection } from "components/MainSectionTemplate/types";
import { ContactFormState } from "contact/models";
import React from "react";
import { formatShortDate } from "utilities";
import { isNullOrEmptyString } from "shared/utils";

export const passportSection = (
  existingContact: ContactFormState,
  sourceContact: ContactFormState,
  currentContact: ContactFormState,
  setCurrentContact: (contact: ContactFormState) => void,
): MergeFormSection => ({
  key: "passsportDetails",
  title: RESX.Guestlist.Passport,
  fields: [{
    key: "nationality",
    label: RESX.Contact.Nationality,
    currentValue: currentContact.nationality,
    existingValue: existingContact.nationality,
    sourceValue: sourceContact.nationality,
    isEmpty: (value) => isNullOrEmptyString(value),
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentContact({ ...currentContact, nationality: sourceContact.nationality }),
    onExistingClick: () => setCurrentContact({ ...currentContact, nationality: existingContact.nationality }),
  }, {
    key: "passportName",
    label: RESX.Contact.NameOnPassport,
    currentValue: currentContact.passportName,
    existingValue: existingContact.passportName,
    sourceValue: sourceContact.passportName,
    isEmpty: (value) => isNullOrEmptyString(value),
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentContact({ ...currentContact, passportName: sourceContact.passportName }),
    onExistingClick: () => setCurrentContact({ ...currentContact, passportName: existingContact.passportName }),
  }, {
    key: "passportNumber",
    label: RESX.Contact.PassportNumber,
    currentValue: currentContact.passportNumber,
    existingValue: existingContact.passportNumber,
    sourceValue: sourceContact.passportNumber,
    isEmpty: (value) => isNullOrEmptyString(value),
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentContact({ ...currentContact, passportNumber: sourceContact.passportNumber }),
    onExistingClick: () => setCurrentContact({ ...currentContact, passportNumber: existingContact.passportNumber }),
  }, {
    key: "passportIssued",
    label: RESX.Contact.PassportIssuedOn,
    currentValue: currentContact.passportIssued,
    existingValue: existingContact.passportIssued,
    sourceValue: sourceContact.passportIssued,
    isEmpty: (value) => !value,
    render: (value) => <span>{formatShortDate(value)}</span>,
    onSourceClick: () => setCurrentContact({ ...currentContact, passportIssued: sourceContact.passportIssued }),
    onExistingClick: () => setCurrentContact({ ...currentContact, passportIssued: existingContact.passportIssued }),
  }, {
    key: "passportExpiration",
    label: RESX.Contact.PassportExpiresOn,
    currentValue: currentContact.passportExpiration,
    existingValue: existingContact.passportExpiration,
    sourceValue: sourceContact.passportExpiration,
    isEmpty: (value) => !value,
    render: (value) => <span>{formatShortDate(value)}</span>,
    onSourceClick: () => setCurrentContact({ ...currentContact, passportExpiration: sourceContact.passportExpiration }),
    onExistingClick: () => setCurrentContact({ ...currentContact, passportExpiration: existingContact.passportExpiration }),
  }]
})